import React from 'react';

import { styled } from '@mui/material';
import { CompositeFundamentalInfoService } from 'application/services';
import { routes } from 'main/router';
import { generatePath } from 'react-router';

const Container = styled('div')({
  width: '100%',
  padding: '1.5rem 1rem',

  '& > table': {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.75rem',

    '& tr': {
      border: '1px solid #0000001F',
      borderLeft: 0,
      borderRight: 0,

      '& th, & td': {
        fontWeight: 400,
        textAlign: 'left',
        padding: '0.5rem 1rem',

        '&:last-of-type': {
          textAlign: 'right'
        }
      },

      '& td': {
        '& a': {
          color: '#000000DE'
        },
        '& span': {
          margin: '0 0.75rem',
          color: '#D32F2F',
          fontWeight: 700
        }
      }
    }
  }
});

export const CompositeFundamental = (
  data?: Partial<CompositeFundamentalInfoService.Response['compositeFundamentals']>
) => {
  if (!data || !data.operations || !data.result) return <></>;

  const { operations, result } = data;

  return (
    <Container>
      <table>
        <thead>
          <tr>
            <th>Period</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {operations.map(({ id, operator, period, value }, index) => (
            <tr key={id}>
              <td>{period}</td>
              <td>
                {index > 0 && <span>{operator}</span>}
                <a href={generatePath(routes.SOURCE, { id })} target="_blank" rel="noreferrer">
                  {value}
                </a>
              </td>
            </tr>
          ))}
          <tr>
            <td>{result.period}</td>
            <td>
              <span>=</span>
              {result.value}
            </td>
          </tr>
        </tbody>
      </table>
    </Container>
  );
};
